module.exports = __webpack_public_path__ + "static/media/charity-3.d86165b6.png";